import axios from "axios";
import cards from "../../models/tarjetas/cards";
import employeed from "../../models/tarjetas/employeed";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getCards({ limit, offset, where } = {}) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    let queryString = "";

    if (!where) {
      const params = new URLSearchParams();
      if (limit !== undefined) params.append("limit", limit);
      if (offset !== undefined) params.append("offset", offset);
      queryString = params.toString() ? `?${params.toString()}` : "";
    } else {
      queryString = `?where=${where}`;
    }

    return axios
      .get(`${url}/tarjetas${queryString}`, { headers })
      .then(({ data }) => {
        return {
          items: data.items.map((item) => cards.fromJson(item)),
          total: data.total,
        };
      })
      .catch((error) => {
        console.error("Error al obtener las tarjetas:", error);
        throw error;
      });
  }

  getCardId(tarjid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/tarjetas/${tarjid}`, { headers })
      .then(({ data }) => data);
  }

  getEmployeedCardId(tarjid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/tarjetas/empleados/${tarjid}`, { headers })
      .then(({ data }) => data);
  }

  addCards(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      tarjetas: data.cards,
    };

    return axios.post(`${url}/tarjetas`, payload, { headers });
  }

  editCard(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if (data.hasOwnProperty("cardNumber")) {
      payload.tarjeta = data.cardNumber;
    }

    if (data.hasOwnProperty("active")) {
      payload.habil = data.active;
    }

    if (data.hasOwnProperty("comment")) {
      payload.comentario = data.comment;
    }

    return axios
      .patch(`${url}/tarjetas/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  getEmployees(operId) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/empleados/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return employeed.fromJson(item);
        })
      );
  }

  addEmployeedCard(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      ...data,
      empId: Number(data.empId),
      operId: Number(data.operId),
      fecDesde: data.fecDesde + "T00:00:00.000Z",
    };
    if (data.fecHasta !== undefined) {
      payload.fecHasta =
        moment.utc(data.fecHasta).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.post(`${url}/emptarj`, payload, { headers });
  }

  deleteEmployeedToCard(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      ...data,
      empId: Number(data.empId),
      tarjId: Number(data.tarjId),
      fecDesde: data.fecDesde + "T00:00:00.000Z",
    };

    return axios.delete(
      `${url}/emptarj/${payload.empId}&${payload.tarjId}&${payload.fecDesde}`,
      { headers }
    );
  }

  editEmployeedCard(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if (data.hasOwnProperty("fecDesde")) {
      data.fecDesde = data.fecDesde + "T00:00:00.000Z";
      if (data.hasOwnProperty("fecDesdeNew")) {
        payload.de = data.fecDesdeNew + "T00:00:00.000Z";
      }
    }

    if (data.hasOwnProperty("fecHastaNew")) {
      payload.ha =
        moment.utc(data.fecHastaNew).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    if (data.hasOwnProperty("haNoEx")) {
      payload.haNoEx = data.haNoEx;
    }

    return axios
      .patch(
        `${url}/emptarj/${data.empId}&${data.tarjId}&${data.fecDesde}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteCard(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/tarjetas/${id}`, { headers });
  }
}

export default service;
